export default "__VITE_ASSET__DGOS1nRu__"